import {
  FAQS,
  TERMS_AND_CONDITION,
  REGISTRATION_TERMS_AND_CONDITION,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/NHL/rangers-logo2-aug21.png";
const OrderSummaryBackgroundImage =
  "https://ss-leagues.s3.amazonaws.com/NHL/New%20York%20Rangers/NYR2627%20-%20Ticketing%20-%20Rangers%20Pass%20-%20Stock%20Image.png";

export const newyorkrangers_pass: TTeamConfig = {
  TEAM_SCHEMA: "newyorkrangers_pass",
  TEAM_FULL_NAME: "New York Rangers",
  BROWSER_TITLE: "New York Rangers Pass",
  CLIENT_ID: "14722a2f1643.seasonshare.msg-msg.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    IS_INTERCOM_ENABLED: true,
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/msg/my-events",
    COLORS_PRIMARY: "#0038A8",
    COLORS_SECONDARY: "#CE1126",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    DISABLE_SIT_WITH_FRIENDS: false,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    IS_CROWD_HANDLER_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      DESKTOP_MAX_HEIGHT: "450px",
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
      SHOW_FAQ_BUTTON: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    DEFAULT_PAGE_TOP_NOTIFICATION: {
      DESCRIPTION:
        "You can hold and manage up to two (2) different game reservations at a time.",
      BACKGROUND_COLOR: "#0038A8",
    },

    ATTEND_EVENT_MODAL: {
      TITLE: "Manage Reservation",
      DESCRIPTION: (
        <>
          Reserving this game will hold 1 of your 2 reservations. If you can no
          longer attend, you can cancel at least 24 hours prior to the start of
          the game and select another available game.
        </>
      ),
      PAID_RESERVATION_DESCRIPTION: (
        <>
          This game requires an additional payment to reserve your seat.
          Clicking <strong>Reserve</strong> will take you to checkout to
          complete your purchase.
        </>
      ),
      CHANGE_SEAT_COUNT_BUTTON_LABEL: "Change Seat Count",
      ATTEND_BUTTON_LABEL: "Reserve",
      NOT_ATTENDING_BUTTON_LABEL: "Cancel Reservation",
      ATTEND_BUTTON_ATTENDING_LABEL: "Reserved",
      ATTEND_BUTTON_NOT_ATTENDING_LABEL: "Not Reserved",

      ATTENDANCE_SUCCESS_TOAST: {
        OPT_IN_SUCCESS_MESSAGE:
          "Your reservation has been updated successfully.",
        OPT_OUT_SUCCESS_MESSAGE:
          "Your reservation has been cancelled successfully.",
      },
    },

    EXCHANGE_RESERVATION_MODAL: {
      DESCRIPTION: (
        <>
          Swap this game in for one of your existing reservations. Your new
          reservation will be confirmed and the selected reservation will be
          cancelled in a single step.
        </>
      ),
      PAID_DESCRIPTION: (
        <>
          This game requires an additional payment to reserve your seat.
          Clicking <strong>Confirm Exchange</strong> will take you to checkout
          to complete your purchase, after which your selected reservation will
          be cancelled.
        </>
      ),
    },

    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_LABEL: "Reserve",

      IS_RESERVATION_ENABLED: true,
      IS_RESERVATION_EXCHANGE_ENABLED: true,

      RESERVATION_LIMIT_REACHED_MESSAGE:
        "You've reached the maximum of two (2) active game reservations. Once one of your reserved games has passed, you'll be able to make a new reservation.",

      RESERVATION_ADD_ON_SEATS_CLAIMED_MESSAGE:
        "This reservation cannot be canceled because additional guest tickets have been purchased for the event.",

      RESERVATION_OPT_OUT_DISABLED_MESSAGE: (
        <>
          The window to cancel your reservation has closed. Please call{" "}
          <a href="tel:212-465-6073">212-465-6073</a> for additional help.
        </>
      ),

      SEAT_COUNT_LIMIT_REACHED_MESSAGE:
        "All seats for this event have been reserved. Please check back in case additional seats become available.",
    },

    ADD_ON: {
      OPT_IN_REQUIRED_MESSAGE:
        "Please complete your pass reservation before purchasing additional guest seats.",
    },

    ZERO_STATE: {
      TITLE: " ",
      DESCRIPTION:
        "No events are currently available for purchase. Please check back later.",
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTRATION_TERMS_AND_CONDITION />,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  PURCHASE_HISTORY_PAGE_SETTINGS: {
    IS_RESEVATION_HISTORY_ENABLED: true,

    PURCHASE_HISTORY_ZERO_STATE: {
      TITLE: "No orders yet",
      DESCRIPTION: "Only purchases made on this platform will appear here.",
    },
  },

  IMAGES: {
    LOGO_URL: LogoImage,
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackgroundImage,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PRE_PURCHASE_FAQS: FAQS,
  },
};
